<template>
    <div
        v-show="show"
        class="tool-box"
        :style="boxStyle"
        @pointerover="handlePointerOver"
        @pointerleave="handlePointerLeave"
        @pointerenter="handlePointerEnter"
    >
        <div class="tool-group">
            <div
                class="group-item"
                :class="{ 'now-group': item.group == currentGroup }"
                v-for="item in toolGroups"
                :key="item.group"
                @pointerover="onGroupItemOver(item.group)"
            >
                {{ item.name }}
            </div>
        </div>
        <div item-key="id" @start="drag = true" @end="drag = false" group="tool" class="tools" :sort="false">
            <template v-for="(element, index) in displayTools" :key="index">
                <div class="tool" :class="[element.TOOL, { off: store.toggleTool[element.TOOL] }]" @pointerdown="handlePointerDown(element, $event)"></div>
            </template>
        </div>
    </div>
</template>

<script>
import {
    TOOL_GROUP,
    TOOLS,
    ALIVE_TYPE,
    WEBVIEW_TYPE_DISABLE_TOOLS,
    WEBVIEW_TYPE_DISABLE_TOOL_GROUPS,
    MAC_DISABLE_TOOLS,
    APP_DISABLE_TOOLS,
    APP_DISABLE_TOOL_GROUPS,
} from "../js/toolbar/tools";
import Debugger from "../js/console/debugger";
import draggable from "vuedraggable";
import EventBus from "../js/event_bus";
import { store } from "../store";
import { settingStore } from "../js/store/settingStore";
import { focusStore } from "../js/store/nowFocusStore";
import { windowContentScaleX, windowContentScaleY } from "../js/common/content_scale";
import { toolbarStore } from "../js/store/toolbarStore";
import { EVENT_TYPE, getPointer } from "../js/event/event";
import { VIEW_TYPE } from "../js/view_type";
import GARecord from "../js/event_GArecord";

import SystemData from "../js/system_data";
export default {
    name: "ToolBox",
    data: function () {
        return {
            show: false,
            toolGroups: [],
            ignoreCloseTools: [TOOLS.PEN_CLICK.TOOL],
            drag: false,
            toolBarPosition: "center",
            currentGroup: "",
            store,
            settingStore,
            dragTool: null,
            prevPoint: { x: 0, y: 0 },
            displayTools: [],
            added: false,
            pointerType: "",
        };
    },
    props: ["nowTools", "dragZone", "toolBarPointerMove", "toolBarPointerUp", "toolBar"],
    components: {
        draggable,
    },
    mounted: function () {
        this.toolGroups = Object.keys(TOOL_GROUP).map((key) => {
            return {
                group: key,
                name: TOOL_GROUP[key],
            };
        });
        if (store.nowView == VIEW_TYPE.WEB) {
            // 過濾網頁版沒有的功能
            this.toolGroups = this.toolGroups.filter((toolGroup) => !WEBVIEW_TYPE_DISABLE_TOOL_GROUPS.includes(toolGroup.group));
        } else if (SystemData.Instance.getPlatform() == "darwin") {
            // 過濾app版沒有的功能
            this.toolGroups = this.toolGroups.filter((toolGroup) => !MAC_DISABLE_TOOLS.includes(toolGroup.group));
        } else if (store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) {
            this.toolGroups = this.toolGroups.filter((toolGroup) => !APP_DISABLE_TOOL_GROUPS.includes(toolGroup.group));
        }
        Debugger.Instance.log({ groups: this.toolGroups }, "toolBox");
        this.currentGroup = this.toolGroups[0].group;

        this.handleDisplayTools();
    },
    methods: {
        onGroupItemOver: function (group) {
            this.currentGroup = group;
            this.handleDisplayTools();
        },
        triggerTool: function (tool) {
            console.log("trigger tool", tool);
            GARecord.Instance.toolClickGARecord(tool);
            // store.nowTool = tool;
            // EventBus.getInstance().emit(tool);
            if (store.toolMap.get(tool)) {
                switch (store.toolMap.get(tool).KEEP_ALIVE) {
                    case ALIVE_TYPE.KEEP:
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        store.setPreviousTool(tool);
                        break;
                    case ALIVE_TYPE.ONCE:
                        EventBus.getInstance().emit(TOOLS.SELECTION.TOOL);
                        store.setPreviousTool(TOOLS.SELECTION.TOOL);
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        break;
                    case ALIVE_TYPE.NONE:
                        EventBus.getInstance().emit(tool);
                        console.log("prev tool:", store.prevTool);
                        store.nowTool = store.prevTool;
                        break;
                }
            } else {
                EventBus.getInstance().emit(tool);
                store.nowTool = store.prevTool;
            }
            if (tool == "tool_box") {
                return;
            }
            if (!this.ignoreCloseTools.includes(tool)) {
                EventBus.getInstance().emit("close_tool_box");
            }
        },
        closeBox() {
            EventBus.getInstance().emit("close_tool_box");
        },
        handlePointerOver() {
            focusStore.setFocusToolBox(true);
        },
        handlePointerLeave() {
            focusStore.setFocusToolBox(false);
        },
        handlePointerEnter() {
            focusStore.setFocusToolBox(true);
        },
        handlePointerDown(tool, e) {
            this.store.isPenDrag = false;
            this.added = false;
            var clone = e.target.cloneNode();
            const pointer = getPointer(e);
            this.store.setDragIconPoint(
                (pointer.x - store.contentSize.x - 41) / windowContentScaleX.value,
                (pointer.y - store.contentSize.y - 41) / windowContentScaleY.value
            );
            this.dragZone.append(clone);
            this.pointerType = e.pointerType;
            window.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.handleWindowPointermove);
            window.addEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.handleWindowPointerup);

            this.dragTool = tool;

            toolbarStore.prevPoint.x = pointer.x;
            toolbarStore.prevPoint.y = pointer.y;
            // EventBus.instance.getAppRefs().toolBar.handleAddTool(this.dragTool, e);
            window.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.toolBarPointerMove);
            // window.addEventListener("pointerup", this.toolBarPointerUp);
        },
        handleWindowPointermove(e) {
            const pointer = getPointer(e);

            if (!this.store.isPenDrag) {
                if (Math.abs(pointer.x - toolbarStore.prevPoint.x) > 3 || Math.abs(pointer.y - toolbarStore.prevPoint.y) > 3) {
                    this.store.isPenDrag = true;
                }
            }

            if (this.added) return;

            switch (settingStore.toolbarPosition) {
                case 0:
                    if (pointer.y - store.contentSize.y > store.contentSize.height - this.store.toolbarHeight) {
                        this.handleAddTool(e);
                    }
                    break;
                case 1:
                    if (pointer.x - store.contentSize.x < this.store.toolbarWidth) {
                        this.handleAddTool(e);
                    }
                    break;
                case 2:
                    if (pointer.x - store.contentSize.x > store.contentSize.width - this.store.toolbarWidth) {
                        this.handleAddTool(e);
                    }
                    break;
            }
        },
        handleAddTool(e) {
            this.added = true;
            EventBus.instance.getAppRefs().toolBar.handleAddTool(this.dragTool, e);
        },
        handleWindowPointerup(e) {
            this.dragZone.removeChild(this.dragZone.firstChild);
            window.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.handleWindowPointermove);
            window.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.toolBarPointerMove);
            window.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.handleWindowPointerup);
            window.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.toolBarPointerUp);

            const self = this;
            setTimeout(() => {
                if (!this.store.isPenDrag) {
                    this.triggerTool(this.dragTool.TOOL);
                }
                self.store.isPenDrag = false;
                self.handleDisplayTools();
            });
        },
        handleDisplayTools() {
            let disabledTools = [];
            let filterArray = this.tools.filter((item) => {
                return TOOL_GROUP[this.currentGroup] == item.GROUP;
            });

            switch(store.nowView) {
                case VIEW_TYPE.WEB:
                    disabledTools = WEBVIEW_TYPE_DISABLE_TOOLS.map((tool) => tool.TOOL_NAME);
                    break;
                case VIEW_TYPE.PC:
                    if (!store.folderPermissions.w) {
                        disabledTools.push(TOOLS.UPDATE.TOOL_NAME);
                    }
                    break;
                case VIEW_TYPE.MAC:
                    disabledTools = MAC_DISABLE_TOOLS.map((tool) => tool.TOOL_NAME);
                    break;
                case VIEW_TYPE.ANDROID:
                case VIEW_TYPE.IOS:
                    disabledTools = APP_DISABLE_TOOLS.map((tool) => tool.TOOL_NAME);
                    break;
            }

            filterArray = filterArray.filter((tool) => !disabledTools.includes(tool.TOOL_NAME));

            let array = [];
            let i = 0,
                j = 0;
            for (i = 0; i < filterArray.length; i++) {
                let isRepeat = false;
                for (j = 0; j < this.nowTools.length; j++) {
                    if (filterArray[i].TOOL == this.nowTools[j].TOOL) {
                        isRepeat = true;
                        break;
                    }
                }
                if (!isRepeat) {
                    array.push(filterArray[i]);
                }
            }
            this.displayTools = array;
        },
    },
    computed: {
        // displayTools: function () {
        //     Debugger.Instance.log({ "tools": this.tools }, "toolBox");
        //     let filterArray = this.tools.filter(item => {
        //         return TOOL_GROUP[this.currentGroup] == item.GROUP;
        //     });
        //     let array = [];
        //     let i = 0, j = 0;
        //     for (i = 0; i < filterArray.length; i++) {
        //         let isRepeat = false;
        //         for (j = 0; j < this.nowTools.length; j++) {
        //             if (filterArray[i].TOOL == this.nowTools[j].TOOL) {
        //                 isRepeat = true;
        //                 break;
        //             }
        //         }
        //         if (!isRepeat) {
        //             array.push(filterArray[i]);
        //         }
        //     }
        //     return array;
        // },
        boxBottom: function () {
            return store.toolbarHeight;
        },
        boxLeft() {
            switch (settingStore.toolbarPosition) {
                case 1:
                    return store.toolbarWidth;
                case 2:
                    return 2;
            }
        },
        boxStyle() {
            switch (settingStore.toolbarPosition) {
                case 0:
                    let maxValue = Math.max(store.pageHeight * 0.08, 64);
                    return { bottom: `${maxValue}px` };
                    return { bottom: this.boxBottom + "px" };
                case 1:
                    return { top: "0px", left: store.toolbarWidth + "px" };
                case 2:
                    return { top: "0px", right: store.toolbarWidth + "px" };
            }
        },
        tools() {
            const _tools = Object.keys(TOOLS).map((key) => {
                return TOOLS[key];
            });
            return _tools;
        },
    },
};
</script>

<style scoped>
.tool-box {
    position: absolute;
    background-color: white;
    border: 2px solid #c7c7c7;
    border-radius: 0.5rem;
    width: 432px;
    height: 512px;
    display: flex;
    z-index: var(--z-index-toolbox);
}

.tool-group {
    background-color: rgb(13, 31, 60);
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.group-item {
    background-color: transparent;
    color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    user-select: none;
    font-size: 18px;
}

.now-group {
    background-color: rgb(93, 100, 220);
}

.tools {
    display: grid;
    flex-wrap: wrap;
    width: 60%;
    height: 100%;

    grid-template-rows: repeat(5, 1fr);

    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 10px;
}

.tool {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    margin: 0 5px;
    cursor: pointer;
}

.ghost-class {
    width: 80%;
}
</style>
